import {
  PUNCH_SOURCE_LABELS,
  PunchBoundaryKey,
  PunchSource,
} from "apis/types/timekeeper";

export const DATE_TIME_FORMAT = "DD-MM-YYYY hh:mm A";

export const BOUNDARY_KEYS: PunchBoundaryKey[] = ["check_in", "check_out"];

export const sourceLabel = (source?: PunchSource | null) =>
  (source && PUNCH_SOURCE_LABELS[source]) || "Unknown source";
